module.exports = "../../static/fonts/Lato-Black.77d3537.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Lato-Black.ttf
// module id = 914
// module chunks = 2